import {
  Box, Card, CardContent, createStyles, makeStyles, Typography,
} from '@material-ui/core';
import * as React from 'react';
import ErrorIcon from '@material-ui/icons/Error';
import openBox from '../../assets/icons/openBox.svg';

const useStyles = makeStyles(() => createStyles({
  root: {
    flexGrow: 1,
  },
  openerCard: {
    height: 180,
  },
  openerSvg: {
    height: 24,
    width: 24,
    marginBottom: 7,
  },
}));

interface CurrentBoxProps {
  trackingNumber: string;
  highPriority: boolean;
}

const CurrentBox: React.FC<CurrentBoxProps> = (props) => {
  const classes = useStyles();
  const { trackingNumber, highPriority } = props;

  return (
    <Card className={classes.openerCard}>
      <CardContent>
        <img src={openBox} alt="openBox.svg" className={classes.openerSvg} />
        <Typography gutterBottom>{'Current Box'}</Typography>
        <Typography variant="h4" className="verticalCenter">
          <Box component="span" mr={1}>{trackingNumber}</Box>
          {highPriority && <ErrorIcon color="error" fontSize="medium" />}
        </Typography>
        <Typography variant="caption" color="textSecondary">{'Tracking Number'}</Typography>
      </CardContent>
    </Card>
  );
};

export default CurrentBox;
